module.exports = __webpack_public_path__ + "img/8-l.86d88751.png";